import { render } from "./PpcBABoostCell.vue?vue&type=template&id=361aee40&scoped=true"
import script from "./PpcBABoostCell.vue?vue&type=script&lang=js"
export * from "./PpcBABoostCell.vue?vue&type=script&lang=js"

import "./PpcBABoostCell.vue?vue&type=style&index=0&id=361aee40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361aee40"]])

export default __exports__